// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"a81052b5","264":"de5e07c9","313":"f37a3bd5","378":"60138619","686":"f6cf8852","742":"c17b1a4c"}[chunkId] + ".js";
};